import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import LatestMovies from '@/pages/home/components/LatestMovies';
import HotRanking from '@/pages/home/components/HotRanking';
import NewsPreview from '@/pages/home/components/NewsPreview';
import AboutSection from '@/pages/home/components/AboutSection';

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryEntry />
      <LatestMovies />
      <HotRanking />
      <NewsPreview />
      <AboutSection />
    </>
  );
}